import { removeSearchParams } from "@/hooks/useUrlBuilder";

export const removeCampaignNavigationSearchParams = (searchParams: Record<string, string>) => {
  return removeSearchParams(
    "new",
    "fundraisers",
    "fundraisersSearch",
    "teamMemberCampaigns",
    "teamMemberCampaignsSearch"
  )(searchParams);
};
